import './AsideToggle.scss';
import React from 'react';
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from 'react-icons/md';

export const AsideCollapseButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
    <button
        type="button"
        className="ws-aside-toggle ws-aside-toggle--collapse"
        onClick={onClick}
        aria-label="Скрыть список позиций"
        title="Скрыть список позиций"
    >
        <MdKeyboardDoubleArrowRight size="18px" />
    </button>
);

export const AsideExpandButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
    <button
        type="button"
        className="ws-aside-toggle ws-aside-toggle--expand"
        onClick={onClick}
        aria-label="Показать список позиций"
        title="Показать список позиций"
    >
        <MdKeyboardDoubleArrowLeft size="22px" />
    </button>
);
